import * as THREE from 'three/build/three.module';
import { J3MaterialMaker } from './J3MaterialMaker';

// Particle Maker & Animator: Ref. https://www.youtube.com/watch?v=OXpl8durSjA

export class J3ParticleMaker extends EventTarget {
    parent:THREE.Object3D;
    particles = null;
    param;
    enable:boolean = false;

    constructor() {
        super();
    }

    MakeParticle(parent:THREE.Object3D, param){
        this.param = param;
        this.parent = parent;
        const materialMaker = new J3MaterialMaker();
        materialMaker.addEventListener('MaterialSet', (evt)=>{this.SetGeometry(evt, param)});
        materialMaker.MakeMaterial(param.material.type, param.material.addTexture, param.material.image, param.material.property);
    }

    SetGeometry(evt, param){
        this.param = param;
        console.log('J3ParticleMaker.SetGeometry()', param.material.type, param.material.property);
        //マテリアルの取得
        const material:THREE.Material = evt.detail.material;
        //Meshの作成
        const geometry = new THREE.BufferGeometry();
        const positions:THREE.Vector3[] = [];
        //初期位置の作成
        const s = param.shape;
        for (let i=0; i < param.amount; i++){
            const x = Math.random() * (s.xmax-s.xmin) + s.xmin;
            const y = Math.random() * (s.ymax-s.ymin) + s.ymin;
            const z = Math.random() * (s.zmax-s.zmin) + s.zmin;
            //const vec = new THREE.Vector3(x,y,z);
            positions.push(x,y,z);
        }
        geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
        // 速度
        const velocities:THREE.Vector3[] = [];
        const v = param.velocity;
        for (let i=0; i < param.amount; i++){
            const x = Math.random() * (v.xmax-v.xmin) + v.xmin;
            const y = Math.random() * (v.ymax-v.ymin) + v.ymin;
            const z = Math.random() * (v.zmax-v.zmin) + v.zmin;
            //const vec = new THREE.Vector3(x,y,z);
            velocities.push(x,y,z);
        }
        geometry.setAttribute('velocity', new THREE.Float32BufferAttribute(velocities, 3));

        console.log('J3ParticleMaker.SetGeometry amount=',velocities.length);
        //const c = param.material.hsl;
        //material.color.setHSL(c[0],c[1],c[2]);
        this.particles = new THREE.Points(geometry, material);
        this.parent.add(this.particles);
        
    }

    Update(dt:number=0.0166666){
        if (!this.param.enable || !this.particles) return;
        //アニメーション
        //console.log('position', this.particles.geometry.attributes.position.array.length, dt);
        //const velArray = this.particles.geometry.attributes.velocity.array;
        const s = this.param.shape;
        for (let i=0; i < this.particles.geometry.attributes.position.array.length; i+=3){ //(x,y,z)を１組に３つおきにループを回す
            //console.log('velocity', velArray[i+1]);
            this.particles.geometry.attributes.position.array[i]   += this.particles.geometry.attributes.velocity.array[i]   * dt;
            this.particles.geometry.attributes.position.array[i+1] += this.particles.geometry.attributes.velocity.array[i+1] * dt;
            this.particles.geometry.attributes.position.array[i+2] += this.particles.geometry.attributes.velocity.array[i+2] * dt;
            //領域外の処理
            if(this.particles.geometry.attributes.position.array[i]   < s.xmin) this.particles.geometry.attributes.position.array[i]   = s.xmax;
            if(this.particles.geometry.attributes.position.array[i+1] < s.ymin) this.particles.geometry.attributes.position.array[i+1] = s.ymax;
            if(this.particles.geometry.attributes.position.array[i+2] < s.zmin) this.particles.geometry.attributes.position.array[i+2] = s.zmax;
            if(this.particles.geometry.attributes.position.array[i]   > s.xmax) this.particles.geometry.attributes.position.array[i]   = s.xmin;
            if(this.particles.geometry.attributes.position.array[i+1] > s.ymax) this.particles.geometry.attributes.position.array[i+1] = s.ymin;
            if(this.particles.geometry.attributes.position.array[i+2] > s.zmax) this.particles.geometry.attributes.position.array[i+2] = s.zmin;
        }
        this.particles.geometry.attributes.position.needsUpdate = true; //アップデートを適用する
    }
}   